export enum GroupingCacheKeysEnum {
  Cart = 'cart',
  User = 'user',
  Address = 'address',
  Favorite = 'favorite',
}
